import React from 'react';
import AccessCodeOnlyForm from '../../StudentIdForm/AccessCodeOnlyForm';
import useQueryString from '../../../hooks/use-query-string';
import AnotherStudentForm from '../../StudentIdForm/AnotherStudentForm';

// The two forms manage their own page-level layout / background so the
// grey backdrop can extend edge-to-edge below the site header. Wrapping
// them in a Grid item xs={11} would leave visible white gutters on both
// sides of the grey card and clip the bottom before the viewport ends.
const StudentIdEntry = () => {
  const { order } = useQueryString();
  const isAnotherStudentFlow = order === 'yearbook_order' || order === 'panorama';

  return isAnotherStudentFlow ? <AnotherStudentForm /> : <AccessCodeOnlyForm />;
};

export default StudentIdEntry;
